import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "../App.css";
import Aili from "../images/aili2_1.webp";
import Calum from "../images/calum5_1.webp";
import Blinded from "../images/blinded1-1.webp";
import Dualities from "../images/dualities1_2.webp";

function Artists() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div>
      {/*ARTISTS IMAGES*/}

      <div data-aos="zoom-out">
        <div className="photo__row">
          {/*BLINDED HEARTS */}
          <Link to="/blindedhearts">
            <div className="photo__container">
              <img src={Blinded} className="photo__size __blinded" />
              <h1 className="text__over__photo __hide">Blinded Hearts</h1>
            </div>
          </Link>

          {/*AILI*/}
          <Link to="/aili">
            <div className="photo__container">
              <img src={Aili} className="photo__size" />
              <h1 className="text__over__photo __hide">Aili</h1>
            </div>
          </Link>
        </div>

        <div className="photo__row">
          <Link to="/dualities">
            <div className="photo__container">
              <img src={Dualities} className="photo__size __aili" />
              <h1 className="text__over__photo __hide">Dualities</h1>
            </div>
          </Link>

          {/*CALUM VENICE */}

          <Link to="/calumvenice">
            <div className="photo__container">
              <img src={Calum} className="photo__size" />
              <h1 className="text__over__photo __hide">Calum Venice</h1>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Artists;
